import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import { getRecommendationProviderDisplayName } from 'app/helpers/bib/bibHelpers';

import './VendorAttributionLabel.scss';

export default function VendorAttributionLabel({ name }) {
  const providerName = getRecommendationProviderDisplayName(name);

  return (
    <div className="cp-vendor-attribution-label">
      <span aria-hidden>{providerName}</span>
      <ScreenReaderMessage>
        <FormattedMessage
          id="sr_vendor_attribution_label"
          values={{
            name: providerName
          }}
        />
      </ScreenReaderMessage>
    </div>
  );
}

VendorAttributionLabel.propTypes = {
  name: PropTypes.string
};
